import {createStyles, makeStyles} from '@material-ui/core';
import {FONT_PRIMARY_COLOR} from 'src/style/variable';

const spaceBottomStyle = {
  marginBottom: '0.5rem'
};

export const useStyles = makeStyles(() =>
  createStyles({
    minutesMenu: {
      '& .MuiPopover-paper': {
        padding: '1rem'
      }
    },
    TextareaAutosize: {
      color: FONT_PRIMARY_COLOR,
      opacity: '1'
    },
    minutePopUp: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      maxWidth: '20rem',
      outline: 0
    },
    minutePopUpHeader: {
      fontSize: '1.5rem',
      color: '#151e24',
      marginBottom: '0.5rem'
    },
    minutesPaletteWrapper: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gap: '0.5rem'
    },
    minutePaletteItem: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: '1px solid #ccc',
      borderRadius: '4px',
      aspectRatio: '1/1'
    },
    minutesButtonsWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem'
    },
    addCCMTimeBillingTitleWrapper: {
      display: 'flex'
    },
    addCCMTimeBillingHeader: {
      ...spaceBottomStyle,
      marginRight: '0.5rem'
    },
    addCCMTimeBillingSubHeader: {
      color: '#5A5A5A',
      ...spaceBottomStyle
    },
    marginBottom: {
      ...spaceBottomStyle
    },
    stopTimeInputWrapper: {
      display: 'flex',
      gap: '0.5rem'
    },
    minuteIconWrapper: {
      marginBottom: '0.5em'
    },
    minuteIcon: {
      paddingBlock: '0rem',
      height: '2.3rem',
      borderRadius: '4px',
      border: '1px solid rgba(0, 0, 0, 0.26)'
    },
    addCCMTimeDialogActions: {
      display: 'flex'
    },
    or: {
      fontSize: '1.5rem',
      color: 'orange',
      textAlign: 'center'
    },
    cancelButton: {
      fontSize: '1.06rem'
    },
    gridPadding: {
      paddingBottom: 0
    },
    formControl: {
      padding: 0
    },
    ccmNotesWrapper: {
      marginTop: '0.7rem'
    },
    prevFollowUpNotesWrapper: {
      marginTop: '1.5rem'
    },
    prevFollowUpNote: {
      marginTop: '0.5rem',
      color: '#54585b',
      lineHeight: 1,
      alignItems: 'flex-start',
      '& .MuiFormControlLabel-label': {
        paddingBlock: 9
      }
    },
    markFollowUpNoteAsDoneWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.3rem',
      paddingTop: 0
    },
    followUpNotesAndMarkAsDoneWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      justifyContent: 'space-between',
      marginTop: '0.5rem'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: 'bold',
      lineHeight: 1
    },
    followUpNotesTitle: {
      marginTop: '0.5rem'
    },
    formControlStyle: {
      paddingBottom: '0',
      marginBottom: '0'
    },
    addButton: {
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      color: 'blue',
      textDecoration: 'underline',
      '&:disabled': {
        color: 'gray',
        cursor: 'not-allowed',
        textDecoration: 'none'
      }
    },
    reasonsInputField: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem'
    }
  })
);
